import { AfterViewInit, AfterViewChecked, Component, Input, ElementRef, OnInit, Renderer2, ViewChild, ViewContainerRef, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';
import { environment } from './../environments/environment';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DragDropModule } from '@angular/cdk/drag-drop';
// import { RouterModule } from '@angular/router';
import { ButtonModule } from 'primeng/button';
import { ToastModule } from 'primeng/toast';
import { SpeedDialModule } from 'primeng/speeddial';
import { ToggleButtonModule } from 'primeng/togglebutton';
import { CardModule } from 'primeng/card';
import { TabViewModule, TabViewChangeEvent, TabView } from 'primeng/tabview';
import { ImageModule } from 'primeng/image';
import { ChipModule } from 'primeng/chip';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { AccordionModule } from 'primeng/accordion';
import { SidebarModule } from 'primeng/sidebar';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ChangeDetectorRef } from '@angular/core';
import { InputSwitchModule } from 'primeng/inputswitch';
import { TooltipModule } from 'primeng/tooltip';
import { DataService } from './service/data.service';
import { CssService } from './service/css.service';
import { } from 'googlemaps';
import agent from "../assets/agents/default-q11.json"
import { CSSStyle } from './http/cssStyle';

@Component({
    selector: 'app-q11bot',
    standalone: true,
    imports: [CommonModule,
        FormsModule,
        DragDropModule,
        ButtonModule,
        ToastModule,
        SpeedDialModule,
        ToggleButtonModule,
        CardModule,
        TabViewModule,
        ImageModule,
        ChipModule,
        InputTextareaModule,
        TooltipModule,
        AccordionModule,
        SidebarModule, InputSwitchModule, FormsModule, ReactiveFormsModule],
    templateUrl: './app.component.html',
    styleUrls: [
        './app.component.css',
        '../../node_modules/primeng/resources/themes/lara-light-blue/theme.css',
        '../../node_modules/primeng/resources/primeng.css',
        '../../node_modules/primeicons/primeicons.css'
    ],
    encapsulation: ViewEncapsulation.ShadowDom,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent implements OnInit, AfterViewInit, AfterViewChecked {

    curAgent!: CSSStyle;
    activeTabIndex = 0;
    characterMax = 1500;
    contactUsForm: FormGroup;
    contactUsMessageError = false;
    contactUsEmailError = false;
    contactUsInfo = "Enter your email and question below";
    contactUsSent = "Email Sent!"
    contactUsCaption = this.contactUsInfo;
    contactUsLoading = false;
    index = 0;
    contactUsErrorMessage = "Sorry, Some Issue Happened. Please Try Again Later!"
    poweredByHyperlink = "https://qwhery.ca"

    adminMessage: string = '';

    @Input() title: string = agent.title;
    @Input() title_bar_color: string = agent.title_bar_color;
    @Input() title_bar_font_color: string = agent.title_bar_font_color;
    @Input() title_bar_logo: string = environment.appDeployUrl + agent.title_bar_logo;
    @Input() logo: string = environment.appDeployUrl + agent.logo;
    @Input() default_open: string = agent.default_open;
    @Input() customer_message_background: string = agent.customer_message_background;
    @Input() response_message_background_color: string = agent.response_message_background_color;
    @Input() user_message_background_color: string = agent.user_message_background_color;
    @Input() user_font_color: string = agent.user_font_color
    @Input() button_color: string = agent.button_color;
    @Input() chat_agent_id: string = agent.chat_agent_id;
    @Input() api_url: string = agent.api_url;
    @Input() chat_background_color: string = agent.chat_background_color
    @Input() chat_font_style: string = agent.chat_font_style
    @Input() chips_font_color: string = agent.chips_font_color
    @Input() button_background_color: string = agent.button_background_color
    @Input() button_logo: string = agent.button_logo
    @Input() chat: boolean = agent.chat
    @Input() settings: boolean = agent.settings
    @Input() help: boolean = agent.help
    @Input() contactus: boolean = agent.contactus
    @Input() doubleview: boolean = agent.doubleview
    @Input() disclaimer: boolean = agent.disclaimer
    @Input() coordinates: number[] | null = agent.coordinates
    @Input() chat_screen_height: string = agent.chat_screen_height
    @Input() button_logo_size: number = agent.button_logo_size

    chatBubble = environment.appDeployUrl + "/assets/typing_bubble.gif"

    @ViewChild('welcomeChat') welcomeChat: ElementRef | undefined;
    @ViewChild('welcomeChat', { read: ViewContainerRef }) targetDiv: ViewContainerRef | undefined;
    @ViewChild('chatExpand', { read: ViewContainerRef }) chatExpandDiv: ViewContainerRef | undefined;
    @ViewChild('chatExpand') expandChat: ElementRef | undefined;
    @ViewChild('tabView') tabView: TabView | undefined;
    @ViewChild('chattingWrapper') chattingWrapper: ElementRef | undefined;
    disclaimerStatement = agent.disclaimerStatement

    showCard: boolean = true;
    showCard1: boolean = true;

    value!: string;
    public isVisited = false;
    isTyping: boolean = true;
    sidebarVisible: boolean = false;
    checked: boolean = false;
    showLocation: boolean = false;
    environment = environment;

    addParentClass: boolean = false;
    addTopParentClass: boolean = false;

    chatButton = true;
    settingButton = true;
    helpButton = true;
    contactusButton = true;

    constructor(
        private formbuilder: FormBuilder,
        public dataService: DataService,
        private changeView: ChangeDetectorRef,
        public cssStyle: CssService,
        private renderer: Renderer2,
        private elementRef: ElementRef) {
        this.contactUsForm = this.formbuilder.group({
            email: ['', [Validators.required, Validators.email]],
            message: ['', [Validators.required]],
            name: [''],
        })
    }

    initMap() {
    }

    test = true

    ngAfterViewChecked() {
        this.dataService.checkExpandView(this.isExpanded, this.renderer, this.chattingWrapper!)
        // Your code to run after view changes
    }

    ngOnInit() {
        this.dataService.randomSessionID(20)
        this.curAgent = {
            chat_title: this.title,
            chat_title_bar_color: this.title_bar_color,
            chat_title_bar_font_color: this.title_bar_font_color,
            chat_title_bar_logo: this.title_bar_logo,
            chat_logo: this.logo,
            chat_default_open: this.default_open,
            chat_background_color: this.chat_background_color,
            customer_message_background: this.customer_message_background,
            response_message_background_color: this.response_message_background_color,
            user_message_background_color: this.user_message_background_color,
            user_font_color: this.user_font_color,
            button_color: this.button_color,
            chat_font_style: this.chat_font_style,
            chips_font_color: this.chips_font_color,
            button_background_color: this.button_background_color,
            button_logo: this.button_logo,
            button_logo_size: this.button_logo_size,

            chat: this.chat,
            settings: this.settings,
            help: this.help,
            contactus: this.contactus,
            doubleview: this.doubleview,
            disclaimer: this.disclaimer,

            api_url: this.api_url,
            chat_agent_id: this.chat_agent_id,
            coordinates: this.coordinates,
        }
        this.cssStyle.properties = this.curAgent

        if (this.curAgent!.chat_default_open == "open") {
            this.showCard = false
        }
        this.cssStyle.updateCSS(this.curAgent, this.chat_screen_height)
        this.changeView.markForCheck()
    }

    ngAfterViewInit() {
        this.dataService.isTyping = false
        this.dataService.updateAskType("start")
        this.dataService.postMessage("", this.targetDiv!, this.changeView, this.chattingWrapper!, this.cssStyle.properties, this.chatExpandDiv!)
    }

    toggleParentClass() { //Opens the side chat
        // this.addTopParentClass = !this.addTopParentClass;
        if (!this.isVisited && !this.isExpanded) {
            this.isVisited = true
            this.addParentClass = true;
            this.cssStyle.maximizeScreen(this.chat_screen_height, true)
            this.addView()
        } else if (this.isVisited && this.isExpanded) {
            this.addParentClass = false;
            this.addView()
        } else if (this.isVisited) {
            this.addParentClass = true;
            this.addView()
        }
    }

    parentDiv = []
    expandedViewIndex: Number[] = []
    isExpanded = false

    addView() {
        this.isExpanded = this.dataService.updateExpandedView(this.isExpanded, this.renderer, this.chattingWrapper!)
    }

    public checkVisited() {
        this.isVisited = !this.isVisited;
        // this.addTopParentClass = !this.addTopParentClass;
        if (!this.isVisited) {
            this.isExpanded = true //Forces addView to be false
        } else {
            this.isExpanded = false //Forces addView to be false
        }
        this.addView()
        this.cssStyle.maximizeScreen(this.chat_screen_height, this.isVisited)
    }

    get charRemaining(): number {
        return this.characterMax - this.contactUsForm.get('message')?.value.length || 0
    }

    get messageErrors(): boolean {
        return this.contactUsForm.get('message')?.errors && (this.contactUsForm.get('message')?.dirty || this.contactUsForm.get('message')?.touched) || this.contactUsMessageError
    }

    get emailErrors(): boolean {
        return this.contactUsForm.get('email')?.errors && (this.contactUsForm.get('email')?.dirty || this.contactUsForm.get('email')?.touched) || this.contactUsEmailError
    }

    onTyping(event: any) {
        if (event.key === 'Enter' && !this.dataService.isTyping) {
            this.isTyping = false
            this.changeView.markForCheck()
            event.preventDefault();
            this.scrollToBottom();
            this.sendMessage();
            this.test = true
        }
    }

    sendMessage() {
        if (this.adminMessage.trim() !== '') {
            if (this.targetDiv) {
                this.dataService.userMessage(this.targetDiv, this.adminMessage, this.changeView, this.chattingWrapper!)
                this.dataService.postMessage(this.adminMessage, this.targetDiv, this.changeView, this.chattingWrapper!, this.cssStyle.properties!, this.chatExpandDiv!)
                this.adminMessage = ''

            }
        }
    }

    scrollToBottom() {
        const chattingWrapperDiv = this.chattingWrapper?.nativeElement;
        if (chattingWrapperDiv) {
            chattingWrapperDiv.scrollTop = chattingWrapperDiv.scrollHeight;
        }
    }

    onInput(event: Event): void {
        // this.isTyping = (event.target as HTMLInputElement).value.length > 0;
    }

    onBlur(): void {
        // this.isTyping = false;
    }

    onEnterPressed(): void {
        // this.isTyping = false;
    }

    onTabChange(event: TabViewChangeEvent) {
        if (this.dataService.disclaimer != "") {
            this.disclaimerStatement = this.dataService.disclaimer
        } else {
            this.disclaimerStatement = agent.disclaimerStatement
        }
        const index = event.index
        if (index != 4) {
            this.contactUsCaption = this.contactUsInfo
            this.clearForm()
        }
    }

    postHelpFromButton() {
        this.dataService.updateAskType('help')
        this.dataService.postMessage('', this.targetDiv!, this.changeView, this.chattingWrapper!, this.cssStyle.properties!, this.chatExpandDiv!)
        this.adminMessage = ''
    }

    clearForm() {
        this.contactUsForm.markAsPristine()
        this.contactUsForm.markAsUntouched()
        this.contactUsForm.patchValue({
            email: '',
            name: '',
            message: '',
        })
    }

    contactUs() {
        this.contactUsLoading = true
        //Check if form was filled out
        if (!this.contactUsForm.get('email')?.errors && !this.contactUsForm.get('message')?.errors) {
            const emailInfo = {
                "email": this.contactUsForm.get('email')?.value,
                "message": this.contactUsForm.get('message')?.value,
                "name": this.contactUsForm.get('name')?.value || '',
            }
            const obervable = this.dataService.sendEmail(emailInfo)
            this.contactUsForm.get('email')?.value
            obervable.subscribe(
                data => {
                    if (data.responseinerror == 'n') {
                        let response = data.response[0] as unknown as { [key: string]: string }
                        let chatMessage = response['chat-message'] as unknown as { [key: string]: string }
                        this.contactUsCaption = chatMessage['message']
                        this.clearForm()
                        this.contactUsLoading = false
                    } else {
                        this.contactUsCaption = this.contactUsErrorMessage
                        this.contactUsLoading = false
                    }
                },
                () => {
                    this.contactUsCaption = this.contactUsErrorMessage
                    this.contactUsLoading = false

                })
        } else { //Otherwise return errors
            if (this.contactUsForm.get('message')?.errors) {
                this.contactUsMessageError = true
            }
            if (this.contactUsForm.get('email')?.errors) {
                this.contactUsEmailError = true
            }
            setTimeout(() => {
                this.contactUsMessageError = false
                this.contactUsEmailError = false
            }, 2000)
            this.contactUsLoading = false
        }
    }
}
